export interface ComicChapter {
  id: string;
  title: string;
  updateTime: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  coverWidth: number;
  coverHeight: number;
  description: string;
  category: string;
  categorySlug: string;
  status: string;
  rating: number;
  views: number;
  updateTime: string;
  chapters: ComicChapter[];
  tags: string[];
}

export interface ComicCategory {
  name: string;
  slug: string;
  icon: string;
  count: number;
  description: string;
}

export const categories: ComicCategory[] = [
  { name: '全部', slug: 'all', icon: 'ri-grid-line', count: 48, description: '所有韩漫作品一览' },
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', count: 12, description: '甜到心底的浪漫韩漫' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', count: 10, description: '异世界奇幻冒险之旅' },
  { name: '动作', slug: 'action', icon: 'ri-sword-line', count: 8, description: '热血沸腾的打斗场面' },
  { name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line', count: 7, description: '扣人心弦的悬疑故事' },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 6, description: '笑到停不下来的欢乐漫画' },
  { name: '剧情', slug: 'drama', icon: 'ri-film-line', count: 5, description: '感人至深的剧情佳作' },
];

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '我的野蛮王妃',
    author: '朴惠莲',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20romance%20cover%20art%2C%20beautiful%20woman%20with%20long%20hair%20in%20elegant%20dress%2C%20royal%20palace%20background%2C%20soft%20warm%20lighting%2C%20digital%20illustration%20style%2C%20delicate%20lineart%2C%20romantic%20atmosphere%2C%20professional%20webtoon%20quality&width=600&height=800&seq=comic-cover-001&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '现代女孩意外穿越到朝鲜时代，成为王妃的她与冷酷王世子展开了一段啼笑皆非的爱情故事。宫廷斗争、身份错位、前世今生的羁绊，这部热门韩漫以其精美的画风和扣人心弦的剧情吸引了无数读者。每周五更新，持续热载中！',
    category: '恋爱',
    categorySlug: 'romance',
    status: '连载中',
    rating: 9.6,
    views: 1280000,
    updateTime: '2026-08-03',
    tags: ['穿越', '宫廷', '甜宠', '逆袭'],
    chapters: [
      { id: 'ch-001-1', title: '第1话 命运的穿越', updateTime: '2026-01-15' },
      { id: 'ch-001-2', title: '第2话 初遇王世子', updateTime: '2026-01-22' },
      { id: 'ch-001-3', title: '第3话 宫廷初体验', updateTime: '2026-01-29' },
      { id: 'ch-001-4', title: '第4话 暗流涌动', updateTime: '2026-02-05' },
      { id: 'ch-001-5', title: '第5话 意外的吻', updateTime: '2026-02-12' },
      { id: 'ch-001-6', title: '第6话 危机四伏', updateTime: '2026-02-19' },
      { id: 'ch-001-7', title: '第7话 真心显露', updateTime: '2026-02-26' },
      { id: 'ch-001-8', title: '第8话 风暴前夕', updateTime: '2026-03-05' },
      { id: 'ch-001-9', title: '第9话 生死之间', updateTime: '2026-03-12' },
      { id: 'ch-001-10', title: '第10话 真相大白', updateTime: '2026-03-19' },
      { id: 'ch-001-11', title: '第11话 新的开始', updateTime: '2026-03-26' },
      { id: 'ch-001-12', title: '第12话 王世子的抉择', updateTime: '2026-04-02' },
      { id: 'ch-001-13', title: '第13话 后宫之争', updateTime: '2026-04-09' },
      { id: 'ch-001-14', title: '第14话 隐藏的身份', updateTime: '2026-04-16' },
      { id: 'ch-001-15', title: '第15话 终极考验', updateTime: '2026-04-23' },
    ],
  },
  {
    id: 'comic-002',
    title: '暗夜猎魔人',
    author: '金成勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20cover%2C%20dark%20haired%20warrior%20with%20sword%20in%20black%20coat%2C%20gothic%20city%20night%20background%2C%20dramatic%20lighting%2C%20mature%20webtoon%20art%20style%2C%20intense%20atmosphere%2C%20professional%20digital%20illustration&width=600&height=800&seq=comic-cover-002&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '在一个被恶魔侵蚀的现代都市中，猎魔人韩振宇游走在黑暗与光明之间。他拥有看穿恶魔伪装的特殊能力，却也因此背负着沉重的宿命。当他遇到神秘少女素妍后，一切开始变得不同。这部动作奇幻韩漫以其炫酷的战斗场面和深刻的人物刻画，长期霸占排行榜前三。',
    category: '动作',
    categorySlug: 'action',
    status: '连载中',
    rating: 9.4,
    views: 965000,
    updateTime: '2026-08-02',
    tags: ['都市', '猎魔', '战斗', '超能力'],
    chapters: [
      { id: 'ch-002-1', title: '第1话 觉醒之夜', updateTime: '2026-02-10' },
      { id: 'ch-002-2', title: '第2话 首战', updateTime: '2026-02-17' },
      { id: 'ch-002-3', title: '第3话 神秘少女', updateTime: '2026-02-24' },
      { id: 'ch-002-4', title: '第4话 深渊之门', updateTime: '2026-03-03' },
      { id: 'ch-002-5', title: '第5话 契约', updateTime: '2026-03-10' },
      { id: 'ch-002-6', title: '第6话 猎魔公会', updateTime: '2026-03-17' },
      { id: 'ch-002-7', title: '第7话 背叛者', updateTime: '2026-03-24' },
      { id: 'ch-002-8', title: '第8话 决战前夜', updateTime: '2026-03-31' },
      { id: 'ch-002-9', title: '第9话 地狱之门', updateTime: '2026-04-07' },
      { id: 'ch-002-10', title: '第10话 觉醒之力', updateTime: '2026-04-14' },
    ],
  },
  {
    id: 'comic-003',
    title: '异世界料理师',
    author: '李智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20cooking%20cover%20art%2C%20cheerful%20young%20chef%20holding%20dishes%20in%20medieval%20fantasy%20kitchen%2C%20warm%20cozy%20colors%2C%20magical%20ingredients%20floating%2C%20charming%20illustration%20style%2C%20soft%20lighting%2C%20whimsical%20atmosphere&width=600&height=800&seq=comic-cover-003&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '顶级韩料大厨意外穿越到剑与魔法的异世界，发现这个世界的料理水平简直不堪入目！凭借一手精湛厨艺，他从路边小摊做起，一路征服巨龙、精灵、王族们的味蕾。美食与冒险交织，温暖又治愈的韩漫佳作，每一话都让人看得口水直流。',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 9.3,
    views: 852000,
    updateTime: '2026-08-04',
    tags: ['穿越', '美食', '冒险', '治愈'],
    chapters: [
      { id: 'ch-003-1', title: '第1话 穿越异世界', updateTime: '2026-03-01' },
      { id: 'ch-003-2', title: '第2话 第一道菜', updateTime: '2026-03-08' },
      { id: 'ch-003-3', title: '第3话 冒险者公会', updateTime: '2026-03-15' },
      { id: 'ch-003-4', title: '第4话 龙族的委托', updateTime: '2026-03-22' },
      { id: 'ch-003-5', title: '第5话 王室宴会', updateTime: '2026-03-29' },
      { id: 'ch-003-6', title: '第6话 传说中的食材', updateTime: '2026-04-05' },
      { id: 'ch-003-7', title: '第7话 竞争对手出现', updateTime: '2026-04-12' },
      { id: 'ch-003-8', title: '第8话 料理大赛', updateTime: '2026-04-19' },
    ],
  },
  {
    id: 'comic-004',
    title: '第七区秘密',
    author: '崔敏浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20mystery%20cover%2C%20detective%20in%20trench%20coat%20standing%20in%20rainy%20alley%2C%20neon%20signs%20reflecting%20on%20wet%20ground%2C%20noir%20atmosphere%2C%20suspenseful%20mood%2C%20mature%20webtoon%20art%20style%2C%20dark%20cinematic%20lighting&width=600&height=800&seq=comic-cover-004&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '首尔第七区接连发生离奇失踪案，刑警金道贤在调查中发现，所有线索都指向一个十年前被尘封的惊天秘密。随着调查深入，他发现自己身边的人一个个都变得可疑起来。这部悬疑韩漫以其层层递进的剧情反转和细腻的心理描写，让人欲罢不能。',
    category: '悬疑',
    categorySlug: 'thriller',
    status: '连载中',
    rating: 9.5,
    views: 721000,
    updateTime: '2026-08-01',
    tags: ['刑侦', '悬疑', '反转', '都市'],
    chapters: [
      { id: 'ch-004-1', title: '第1话 失踪者', updateTime: '2026-02-20' },
      { id: 'ch-004-2', title: '第2话 第一个线索', updateTime: '2026-02-27' },
      { id: 'ch-004-3', title: '第3话 证人', updateTime: '2026-03-06' },
      { id: 'ch-004-4', title: '第4话 十年前', updateTime: '2026-03-13' },
      { id: 'ch-004-5', title: '第5话 另一个失踪者', updateTime: '2026-03-20' },
      { id: 'ch-004-6', title: '第6话 嫌疑人', updateTime: '2026-03-27' },
      { id: 'ch-004-7', title: '第7话 反转', updateTime: '2026-04-03' },
      { id: 'ch-004-8', title: '第8话 真相碎片', updateTime: '2026-04-10' },
      { id: 'ch-004-9', title: '第9话 幕后黑手', updateTime: '2026-04-17' },
    ],
  },
  {
    id: 'comic-005',
    title: '社长大人请自重',
    author: '尹秀雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20comedy%20manhwa%20cover%2C%20handsome%20CEO%20in%20suit%20and%20cute%20office%20woman%2C%20modern%20office%20background%2C%20bright%20cheerful%20colors%2C%20playful%20romantic%20mood%2C%20clean%20webtoon%20illustration%20style%2C%20soft%20pastel%20tones&width=600&height=800&seq=comic-cover-005&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '平凡上班族林小暖意外成为了霸道社长的私人秘书，本以为是一场职场噩梦，却发现这位冷面社长私下竟然是个超级暖男！办公室恋情、职场斗争、闺蜜助攻，这部搞笑恋爱韩漫甜度爆表，每看一话都能让你嘴角疯狂上扬。',
    category: '恋爱',
    categorySlug: 'romance',
    status: '已完结',
    rating: 9.2,
    views: 1100000,
    updateTime: '2026-07-15',
    tags: ['办公室', '霸道总裁', '甜宠', '搞笑'],
    chapters: [
      { id: 'ch-005-1', title: '第1话 面试奇遇', updateTime: '2025-11-01' },
      { id: 'ch-005-2', title: '第2话 第一天上班', updateTime: '2025-11-08' },
      { id: 'ch-005-3', title: '第3话 加班之夜', updateTime: '2025-11-15' },
      { id: 'ch-005-4', title: '第4话 出差意外', updateTime: '2025-11-22' },
      { id: 'ch-005-5', title: '第5话 情敌登场', updateTime: '2025-11-29' },
      { id: 'ch-005-6', title: '第6话 社长的秘密', updateTime: '2025-12-06' },
      { id: 'ch-005-7', title: '第7话 告白', updateTime: '2025-12-13' },
      { id: 'ch-005-8', title: '第8话 大结局', updateTime: '2025-12-20' },
    ],
  },
  {
    id: 'comic-006',
    title: '无限升级系统',
    author: '郑宇硕',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20leveling%20system%20cover%2C%20young%20male%20hunter%20with%20glowing%20blue%20energy%2C%20dungeon%20portal%20background%2C%20game%20interface%20hologram%2C%20dynamic%20action%20pose%2C%20vibrant%20digital%20illustration%20style%2C%20epic%20fantasy%20atmosphere&width=600&height=800&seq=comic-cover-006&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '全球突然出现无数异次元裂缝，怪物肆虐人间。普通高中生姜贤宇在濒死之际觉醒了独一无二的"无限升级系统"。从此，他踏上了一条不断突破极限的练级之路。S级猎人、传说级装备、隐藏副本——这部韩漫融合了游戏系统和热血战斗，让人看得根本停不下来！',
    category: '动作',
    categorySlug: 'action',
    status: '连载中',
    rating: 9.7,
    views: 1560000,
    updateTime: '2026-08-04',
    tags: ['系统', '升级', '热血', '打怪'],
    chapters: [
      { id: 'ch-006-1', title: '第1话 末日降临', updateTime: '2026-01-05' },
      { id: 'ch-006-2', title: '第2话 觉醒', updateTime: '2026-01-12' },
      { id: 'ch-006-3', title: '第3话 首次任务', updateTime: '2026-01-19' },
      { id: 'ch-006-4', title: '第4话 隐藏副本', updateTime: '2026-01-26' },
      { id: 'ch-006-5', title: '第5话 公会邀请', updateTime: '2026-02-02' },
      { id: 'ch-006-6', title: '第6话 S级首战', updateTime: '2026-02-09' },
      { id: 'ch-006-7', title: '第7话 传说武器', updateTime: '2026-02-16' },
      { id: 'ch-006-8', title: '第8话 世界BOSS', updateTime: '2026-02-23' },
      { id: 'ch-006-9', title: '第9话 新的敌人', updateTime: '2026-03-02' },
      { id: 'ch-006-10', title: '第10话 极限突破', updateTime: '2026-03-09' },
      { id: 'ch-006-11', title: '第11话 联合讨伐', updateTime: '2026-03-16' },
      { id: 'ch-006-12', title: '第12话 真相浮现', updateTime: '2026-03-23' },
    ],
  },
  {
    id: 'comic-007',
    title: '噗通噗通心跳',
    author: '韩素希',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20school%20romance%20manhwa%20cover%2C%20cute%20high%20school%20couple%20under%20cherry%20blossom%20tree%2C%20spring%20pastel%20colors%2C%20youthful%20sweet%20atmosphere%2C%20shojo%20style%20illustration%2C%20sparkling%20effects%2C%20gentle%20warm%20lighting&width=600&height=800&seq=comic-cover-007&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '高中校园里的甜蜜初恋故事。学霸少女和运动少年因为一次意外成为同桌，从此开始了让人心跳加速的校园生活。友情、暗恋、青春期的那些小心思，这部韩漫用最细腻的笔触描绘了最美好的青春回忆。',
    category: '恋爱',
    categorySlug: 'romance',
    status: '已完结',
    rating: 9.1,
    views: 890000,
    updateTime: '2026-06-20',
    tags: ['校园', '初恋', '青春', '甜宠'],
    chapters: [
      { id: 'ch-007-1', title: '第1话 新同桌', updateTime: '2025-09-01' },
      { id: 'ch-007-2', title: '第2话 便当事件', updateTime: '2025-09-08' },
      { id: 'ch-007-3', title: '第3话 体育祭', updateTime: '2025-09-15' },
      { id: 'ch-007-4', title: '第4话 雨天的伞', updateTime: '2025-09-22' },
      { id: 'ch-007-5', title: '第5话 文化祭', updateTime: '2025-09-29' },
      { id: 'ch-007-6', title: '第6话 圣诞节', updateTime: '2025-12-25' },
    ],
  },
  {
    id: 'comic-008',
    title: '修仙聊天群',
    author: '张太贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20fantasy%20manhwa%20cover%2C%20modern%20young%20man%20with%20smartphone%20surrounded%20by%20martial%20arts%20cultivators%2C%20humorous%20expression%2C%20bright%20colorful%20illustration%2C%20mashup%20of%20modern%20and%20ancient%20elements%2C%20fun%20playful%20mood&width=600&height=800&seq=comic-cover-008&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '普通大学生意外加入了一个神秘的修仙聊天群，群里全是真正的修仙者！从此他一边上课一边修仙，用现代思维在修真界混得风生水起。外卖送丹药、淘宝买法器、直播渡天劫——这部脑洞大开的搞笑韩漫承包了你一整年的笑点。',
    category: '搞笑',
    categorySlug: 'comedy',
    status: '连载中',
    rating: 9.0,
    views: 678000,
    updateTime: '2026-08-03',
    tags: ['修仙', '搞笑', '现代', '脑洞'],
    chapters: [
      { id: 'ch-008-1', title: '第1话 入群须知', updateTime: '2026-03-15' },
      { id: 'ch-008-2', title: '第2话 第一颗丹药', updateTime: '2026-03-22' },
      { id: 'ch-008-3', title: '第3话 群内斗法', updateTime: '2026-03-29' },
      { id: 'ch-008-4', title: '第4话 外卖飞剑', updateTime: '2026-04-05' },
      { id: 'ch-008-5', title: '第5话 渡劫直播', updateTime: '2026-04-12' },
      { id: 'ch-008-6', title: '第6话 宗门考核', updateTime: '2026-04-19' },
    ],
  },
  {
    id: 'comic-009',
    title: '重生之影后归来',
    author: '权恩菲',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20drama%20manhwa%20cover%2C%20glamorous%20actress%20on%20red%20carpet%20with%20spotlight%2C%20elegant%20evening%20gown%2C%20dramatic%20staging%2C%20luxurious%20atmosphere%2C%20mature%20sophisticated%20webtoon%20art%2C%20golden%20and%20rose%20color%20palette&width=600&height=800&seq=comic-cover-009&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '曾经红极一时的影后苏婉清被最信任的人联手陷害，从神坛跌落谷底。重生回到十年前，她带着所有记忆重新出发。这一次，她要让所有背叛她的人付出代价，重新夺回属于自己的荣耀。这部剧情韩漫情节紧凑，每集都充满戏剧张力。',
    category: '剧情',
    categorySlug: 'drama',
    status: '连载中',
    rating: 9.4,
    views: 935000,
    updateTime: '2026-08-02',
    tags: ['重生', '娱乐圈', '复仇', '逆袭'],
    chapters: [
      { id: 'ch-009-1', title: '第1话 陨落', updateTime: '2026-02-01' },
      { id: 'ch-009-2', title: '第2话 重生', updateTime: '2026-02-08' },
      { id: 'ch-009-3', title: '第3话 第一步棋', updateTime: '2026-02-15' },
      { id: 'ch-009-4', title: '第4话 试镜', updateTime: '2026-02-22' },
      { id: 'ch-009-5', title: '第5话 重逢故人', updateTime: '2026-03-01' },
      { id: 'ch-009-6', title: '第6话 反击开始', updateTime: '2026-03-08' },
      { id: 'ch-009-7', title: '第7话 颁奖典礼', updateTime: '2026-03-15' },
      { id: 'ch-009-8', title: '第8话 旧友新敌', updateTime: '2026-03-22' },
      { id: 'ch-009-9', title: '第9话 曝光', updateTime: '2026-03-29' },
    ],
  },
  {
    id: 'comic-010',
    title: '末日生存指南',
    author: '吴尚宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20post%20apocalyptic%20manhwa%20cover%2C%20survivor%20with%20backpack%20and%20weapon%20in%20ruined%20city%2C%20dramatic%20orange%20sunset%20sky%2C%20destroyed%20buildings%2C%20tense%20survival%20mood%2C%20realistic%20detailed%20art%20style%2C%20cinematic%20composition&width=600&height=800&seq=comic-cover-010&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '一场突如其来的病毒席卷全球，百分之九十的人类变成了丧尸。普通上班族朴志浩凭借缜密的思维和过人的生存技能，在末日废墟中艰难求生。寻找家人、组建幸存者团队、对抗变异丧尸——这部悬疑动作韩漫每一帧都紧张到令人窒息。',
    category: '悬疑',
    categorySlug: 'thriller',
    status: '连载中',
    rating: 9.3,
    views: 802000,
    updateTime: '2026-08-04',
    tags: ['末日', '生存', '丧尸', '人性'],
    chapters: [
      { id: 'ch-010-1', title: '第1话 爆发之日', updateTime: '2026-02-28' },
      { id: 'ch-010-2', title: '第2话 逃离都市', updateTime: '2026-03-07' },
      { id: 'ch-010-3', title: '第3话 第一次遭遇', updateTime: '2026-03-14' },
      { id: 'ch-010-4', title: '第4话 幸存者', updateTime: '2026-03-21' },
      { id: 'ch-010-5', title: '第5话 补给站', updateTime: '2026-03-28' },
      { id: 'ch-010-6', title: '第6话 夜间袭击', updateTime: '2026-04-04' },
      { id: 'ch-010-7', title: '第7话 变异体', updateTime: '2026-04-11' },
    ],
  },
  {
    id: 'comic-011',
    title: '精灵王的契约',
    author: '姜秀晶',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20cover%2C%20beautiful%20elf%20king%20with%20long%20silver%20hair%20and%20human%20woman%2C%20enchanted%20forest%20background%20with%20glowing%20lights%2C%20ethereal%20magical%20atmosphere%2C%20elegant%20detailed%20illustration%2C%20soft%20dreamy%20colors&width=600&height=800&seq=comic-cover-011&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '平凡女孩林雨薇在古老书店发现了一本神秘契约书，签下名字的瞬间，她与精灵王艾尔文缔结了不可违背的主从之约。精灵王国、魔法学院、千年预言，当她一步步揭开契约背后的秘密时，一段跨越种族的禁忌之恋也悄然绽放。',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 9.5,
    views: 768000,
    updateTime: '2026-08-01',
    tags: ['精灵', '魔法', '契约', '异世界'],
    chapters: [
      { id: 'ch-011-1', title: '第1话 神秘契约书', updateTime: '2026-03-05' },
      { id: 'ch-011-2', title: '第2话 精灵王国', updateTime: '2026-03-12' },
      { id: 'ch-011-3', title: '第3话 契约的代价', updateTime: '2026-03-19' },
      { id: 'ch-011-4', title: '第4话 魔法学院', updateTime: '2026-03-26' },
      { id: 'ch-011-5', title: '第5话 森林试炼', updateTime: '2026-04-02' },
      { id: 'ch-011-6', title: '第6话 公主的嫉妒', updateTime: '2026-04-09' },
      { id: 'ch-011-7', title: '第7话 禁忌之恋', updateTime: '2026-04-16' },
    ],
  },
  {
    id: 'comic-012',
    title: '武林第一高手',
    author: '白贤宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20murim%20manhwa%20cover%2C%20master%20swordsman%20in%20traditional%20hanbok%20on%20mountain%20peak%2C%20dramatic%20wind%20effects%2C%20ink%20wash%20painting%20style%2C%20epic%20oriental%20atmosphere%2C%20powerful%20dynamic%20composition%2C%20professional%20manhwa%20quality&width=600&height=800&seq=comic-cover-012&orientation=portrait',
    coverWidth: 600,
    coverHeight: 800,
    description: '江湖传言，魔教教主即将出关，武林正面临灭顶之灾。隐居深山二十年的前武林盟主独孤辰被迫重出江湖，却发现昔日的武林早已物是人非。新一代高手崛起，旧日恩怨浮现，一场关乎武林存亡的大战即将拉开序幕。',
    category: '剧情',
    categorySlug: 'drama',
    status: '连载中',
    rating: 9.2,
    views: 598000,
    updateTime: '2026-07-30',
    tags: ['武侠', '江湖', '热血', '传统'],
    chapters: [
      { id: 'ch-012-1', title: '第1话 隐居深山', updateTime: '2026-04-01' },
      { id: 'ch-012-2', title: '第2话 魔教来袭', updateTime: '2026-04-08' },
      { id: 'ch-012-3', title: '第3话 故人重逢', updateTime: '2026-04-15' },
      { id: 'ch-012-4', title: '第4话 比武大会', updateTime: '2026-04-22' },
      { id: 'ch-012-5', title: '第5话 暗器高手', updateTime: '2026-04-29' },
    ],
  },
];

export const hotComics = comics.filter((c) => c.rating >= 9.4).slice(0, 6);
export const newComics = [...comics].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()).slice(0, 6);

export function getComicsByCategory(slug: string): Comic[] {
  if (slug === 'all') return comics;
  return comics.filter((c) => c.categorySlug === slug);
}

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getCategoryBySlug(slug: string): ComicCategory | undefined {
  return categories.find((c) => c.slug === slug);
}